const experienceQuestions = [
  {
    id: "Q001",
    text: "The therapist listened carefully.",
    image: "/assets/screen6-assets/1.webp",
  },
  {
    id: "Q002",
    text: "The therapist explained the treatment.",
    image: "/assets/screen6-assets/2.webp",
  },
  {
    id: "Q003",
    text: "I felt respected.",
    image: "/assets/screen6-assets/3.webp",
  },
  {
    id: "Q004",
    text: "The environment felt peaceful.",
    image: "/assets/screen6-assets/4.webp",
  },
  {
    id: "Q005",
    text: "I would recommend this therapy to others.",
    image: "/assets/screen6-assets/5.webp",
  },
];

const ratingValues = [1, 2, 3, 4, 5];
const filledStar = "\u2605";
const emptyStar = "\u2606";

function ExperienceRating({ question, rating, onRatingChange }) {
  const questionId = `experience-question-${question.id}`;

  return (
    <article className="experience-row">
      <img src={question.image} alt="" aria-hidden="true" />
      <p id={questionId}>{question.text}</p>
      <fieldset className="experience-stars" aria-labelledby={questionId}>
        <legend className="visually-hidden">Rate from 1 to 5</legend>
        {ratingValues.map((value) => (
          <label
            className={`experience-star${value <= rating ? " is-filled" : ""}`}
            key={value}
          >
            <input
              type="radio"
              name={`experience[${question.id}]`}
              value={value}
              checked={rating === value}
              onChange={() => onRatingChange(question.id, value)}
              aria-label={`${value} out of 5 for ${question.text}`}
            />
            <span aria-hidden="true">
              {value <= rating ? filledStar : emptyStar}
            </span>
          </label>
        ))}
      </fieldset>
    </article>
  );
}

const ScreenSix = ({ experience, onExperienceChange }) => {
  return (
    <section className="screen-six" aria-labelledby="screen-six-title">
      <h1 className="visually-hidden" id="screen-six-title">
        Therapy Experience
      </h1>

      <aside className="screen-six__intro left-side" aria-hidden="true">
        <div className="screen-six__intro-title">
          <strong>Therapy</strong>
          <span>Experience</span>
        </div>
        <img
          className="screen-six__intro-divider"
          src="/assets/screen4-assets/line.webp"
          alt=""
        />
        <p>Please rate the following statements</p>
      </aside>

      <div className="content-side">
        <div className="screen-six__main main-content">
        <div className="experience-list">
          {experienceQuestions.map((question) => (
            <ExperienceRating
              question={question}
              rating={experience[question.id] || 0}
              onRatingChange={onExperienceChange}
              key={question.id}
            />
          ))}
        </div>

        <section
          className="experience-care-note"
          aria-label="Your experience helps us care better."
        >
          <img
            className="experience-care-note__branch experience-care-note__branch--left"
            src="/assets/screen6-assets/golden_leaf.webp"
            alt=""
            aria-hidden="true"
          />
          <div>
            <span aria-hidden="true">{`\u2661`}</span>
            <strong>Your experience helps us care better.</strong>
          </div>
          <img
            className="experience-care-note__branch experience-care-note__branch--right"
            src="/assets/screen6-assets/golden_leaf.webp"
            alt=""
            aria-hidden="true"
          />
        </section>
        </div>
      </div>
    </section>
  );
}

export default ScreenSix;
